import { ApiContext } from "../contexts/ApiContext";
import { useContext } from "react";
import { useQuery } from "react-query";

export function useCompaniesByCustomerId(customerId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["companiesByCustomerId", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.companyApis.getCompaniesByCustomerId(customerId);
    },
  });
}
